import Header from '../utill/Header'
import Footer from '../utill/Footer'
import Sidebar from '../utill/Sidebar'
import {Button, Card, Form, Table} from "react-bootstrap";
import React, {ChangeEvent, useContext, useEffect, useState} from "react";
import {Link, useNavigate} from "react-router-dom";
import axios from "axios";
import Url from "../utill/Url";
import {useSelector} from "react-redux";
import {reissue} from "../utill/UtilComponent";
import {
    Paper,
    TableBody,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {RootState} from "../../redux/store";
import StyledTableCell from "../utill/StyledTableCell"

interface User {
    userId: string;
    userName: string;
    customerCode: string;
    customerName: string;
    authorityName: string;
    deleteYn: string;
    deleteDtm: string;
    registerUser: string;
    registerDtm: string;
    updateUser: string;
    updateDtm: string;
}

interface Authority {
    authorityId: string;
    authorityName: string;
}

function WebUserManagement() {
    const url = useContext(Url)
    const [data, setData] = useState<User[]>([]);
    const [totalData, setTotalData] = useState();
    const [searchText, setSearchText] = useState('');
    const navigate = useNavigate();
    const [customerCodeSelected, setCustomerCodeSelected] = useState("");
    const [authoritySelected, setAuthoritySelected] = useState("");
    const [customerCode, setCustomerCode] = useState<User[]>([]);
    const [authority, setAuthority] = useState<Authority[]>([]);
    const user = useSelector((state: RootState) => state.user.value);
    let userId = user.id;
    const auth = useSelector((state: RootState) => state.loginAuth.value);
    const [writeAuthorityYn, setWriteAuthorityYn] = useState(false);

    useEffect(() => {
        document.title = 'Mcon 모니터링 시스템-웹 계정 관리'
        if (auth.MENUAUTH?.SET0300?.readAuthorityYn !== "1") {
            alert('페이지를 볼 수 있는 권한이 없습니다.');
            navigate(auth.firstUrl);
        }
        setWriteAuthorityYn(auth.MENUAUTH?.SET0300?.writeAuthorityYn === "1");
        reissue(userId, url, navigate).then(() => {
            axios.get(url + 'admin/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setData(response.data.result.data)
                setTotalData(response.data.result.totalData)
            })
            axios.get(url + 'customercode/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setCustomerCode(response.data.result.data)
                setCustomerCodeSelected(response.data.result.data[0].customerName)
            })
            axios.get(url + 'authority/findall', {
                headers: {
                    'Authorization': localStorage.getItem('Authorization')
                }
            }).then((response) => {
                setAuthority(response.data.result.data)
                setAuthoritySelected(response.data.result.data[0].authorityName)
            })
        })
    }, []);

    const handleSubmit = async () => {
        reissue(userId, url, navigate).then(() => {
            try {
                let data;
                if (selected === "1" || selected === "2") {
                    data = searchText
                } else if (selected === "3") {
                    data = customerCodeSelected
                } else if (selected === "4") {
                    data = authoritySelected
                }
                axios.get(url + 'admin/find', {
                    headers: {
                        'Authorization': localStorage.getItem('Authorization')
                    },
                    params: {
                        type: selected,
                        data: data
                    }
                }).then((response) => {
                    setData(response.data.result.data);
                    setTotalData(response.data.result.totalData);
                })
            } catch (e) {
                console.error(e);
            }
        })
    };

    const handleJoinClick = () => {
        navigate('/WebUserAdd');
    };

    const handleKeyDown = (e: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>) => {
        const key = e.code;
        if (key === 'Enter' || key === 'NumpadEnter') {
            e.preventDefault();
            handleSubmit();
        }
    }

    const [selected, setSelected] = useState("1");
    const handleChangeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setSelected(e.target.value)
    }

    const handleChangeAuthoritySelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setAuthoritySelected(e.target.value)
    }

    const handleChangeCustomerCodeSelect = (e: ChangeEvent<HTMLSelectElement>) => {
        setCustomerCodeSelected(e.target.value)
    }

    let selectedValueTitle = "";
    let selectedValueContent = "";

    if (selected === "1") {
        selectedValueTitle = "아이디로";
        selectedValueContent = "아이디를";
    } else if (selected === "2") {
        selectedValueTitle = "이름으로";
        selectedValueContent = "이름을";
    } else if (selected === "3") {
        selectedValueTitle = "회사명으로";
        selectedValueContent = "회사명을";
    } else if (selected === "4") {
        selectedValueTitle = "권한명으로";
        selectedValueContent = "권한명을";
    }

    

    return (
        <div id="wrapper">
            <Sidebar menuCode={"SET0300"}/>
            <div id="content-wrapper" className="d-flex flex-column">
                <div id="content">
                    <div className="container-fluid">
                        <Header pageName='웹 계정 관리'/>
                        <p className="header-message">웹 유저의 계정을 관리합니다. 해당 아이디, 이름, 회사명, 권한명을 클릭하면 정보를 수정, 삭제 할 수 있습니다.</p>
                        <br/>
                        <Card className="card shadow mb-4">
                            <Card.Header className="py-3">
                                <div style={{display: "flex"}}>
                                    <div>
                                        <h6 className="m-0 font-weight-bold text-primary">{selectedValueTitle} 검색</h6>
                                        <p className="mb-2 mt-2 basic_font">{selectedValueContent} 기준으로 조회 합니다.</p>
                                    </div>
                                    {writeAuthorityYn && <div style={{marginLeft: "auto"}}>
                                        <Button onClick={handleJoinClick}>웹 계정 등록</Button>
                                    </div>}
                                </div>
                                <Form id="searchForm">
                                    <div className='form-group row'>
                                        <div className='search_area'>
                                            <Form.Select className='select_box' id='search_select' value={selected}
                                                         onChange={handleChangeSelect}>
                                                <option value="1">아이디</option>
                                                <option value="2">이름</option>
                                                <option value="3">회사명</option>
                                                <option value="4">권한명</option>
                                            </Form.Select>
                                            {selected === '1' || selected === '2' ?
                                                (<Form.Control type="text" placeholder="검색" value={searchText}
                                                               onChange={(e) => setSearchText(e.target.value)}
                                                               onKeyDown={handleKeyDown}/>) : selected === '3' ?
                                                    (<Form.Select className="select_box device"
                                                                  value={customerCodeSelected}
                                                                  onChange={handleChangeCustomerCodeSelect}
                                                                  name="customerCode">
                                                        {customerCode.map(customerCode => (
                                                            <option key={customerCode.customerCode}
                                                                    value={customerCode.customerName}>{customerCode.customerName}</option>))}
                                                    </Form.Select>) : (<Form.Select className="select_box device"
                                                                                    value={authoritySelected}
                                                                                    onChange={handleChangeAuthoritySelect}
                                                                                    name="authority">
                                                        {authority.map(authority => (
                                                            <option key={authority.authorityId}
                                                                    value={authority.authorityName}>{authority.authorityName}</option>
                                                        ))}
                                                    </Form.Select>)}
                                        </div>
                                        <div className='search_button_area'>
                                            <Button variant="primary" onClick={handleSubmit}
                                                    className='search_button'>검색</Button>
                                        </div>
                                    </div>
                                </Form>
                            </Card.Header>
                            <Card.Body>
                                <div style={{display: 'flex'}}>
                                    <p className='card-body_content'>검색 결과 : 총 {totalData}건</p>
                                </div>
                                <TableContainer component={Paper}>
                                    <Table style={{marginBottom: 0}} aria-label="simple table">
                                        <TableHead>
                                            <TableRow>
                                                <StyledTableCell align="center">아이디</StyledTableCell>
                                                <StyledTableCell align="center">이름</StyledTableCell>
                                                <StyledTableCell align="center">회사명</StyledTableCell>
                                                <StyledTableCell align="center">권한명</StyledTableCell>
                                                <StyledTableCell align="center">삭제 여부</StyledTableCell>
                                                <StyledTableCell align="center">삭제 일시</StyledTableCell>
                                                <StyledTableCell align="center">등록자</StyledTableCell>
                                                <StyledTableCell align="center">등록일시</StyledTableCell>
                                                <StyledTableCell align="center">수정자</StyledTableCell>
                                                <StyledTableCell align="center">수정일시</StyledTableCell>
                                            </TableRow>
                                        </TableHead>
                                        {writeAuthorityYn ? (<TableBody>
                                            {data.map(user => (
                                                <TableRow component={Link} to='/WebUserModify' key={user.userId} className="custom-link" state={{
                                                    id: user.userId,
                                                    userName: user.userName,
                                                    customerName: user.customerName,
                                                    authorityName: user.authorityName
                                                }} sx={{
                                                    '&:hover td': {
                                                        backgroundColor: 'rgba(0,111,255,0.13)'
                                                    },
                                                    '&:active td': {
                                                        backgroundColor: 'rgba(0,149,255,0.13)'
                                                    }
                                                }}>
                                                    <StyledTableCell align="center">{user.userId || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.userName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.customerName?user.customerName:'텔레컨스' || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.authorityName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.deleteYn === "0" ? "사용중" : "삭제됨"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.deleteDtm ? user.deleteDtm.replace('T', ' ') : "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.registerUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.registerDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.updateUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.updateDtm.replace('T', ' ') || "-"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>):(<TableBody>
                                            {data.map(user => (
                                                <TableRow key={user.userId} className="custom-link"
                                                          sx={{
                                                    '&:hover td': {
                                                        backgroundColor: 'rgba(0,111,255,0.13)'
                                                    },
                                                    '&:active td': {
                                                        backgroundColor: 'rgba(0,149,255,0.13)'
                                                    }
                                                }}>
                                                    <StyledTableCell align="center">{user.userId || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.userName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.customerName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.authorityName || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.deleteYn === "0" ? "사용중" : "삭제됨"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.deleteDtm ? user.deleteDtm.replace('.0', '') : "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.registerUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.registerDtm.replace('.0', '') || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.updateUser || "-"}</StyledTableCell>
                                                    <StyledTableCell align="center">{user.updateDtm.replace('.0', '') || "-"}</StyledTableCell>
                                                </TableRow>
                                            ))}
                                        </TableBody>)}
                                    </Table>
                                </TableContainer>
                            </Card.Body>
                        </Card>
                    </div>
                </div>
                <Footer/>
            </div>
        </div>
    );
}

export default WebUserManagement;